import React, { useEffect } from "react";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import { LastLocationProvider } from 'react-router-last-location';
import { useSelector } from "react-redux";
import URL from "../constant/URL";
import EntryExternalAppDataAndAutoLogin from "./provider/EntryExternalAppDataAndAutoLogin";
import HideSplashScreen from "./provider/HideSplashScreen";
import SpinnerLoading from "./loading/SpinnerLoading";
import MathJax from "./common/mathjax/MathJax";
import SelectLearning from "./main/SelectLearning";
import AsideV2 from "./navigate/AsideV2";
import IntroductionV2 from "./information/IntroductionV2";
import CourseLearning from "./learning/courseLearning/CourseLearning";
import TutorialInitializer from "./answeringQuestions/tutorial/container/TutorialInitializer";
import Tutorial from "./answeringQuestions/tutorial/presentational/Tutorial";
import Learning from "./learning/Learning";
import Sound from "./sound/Sound";
import EntryCheck from "./provider/EntryCheck";
import ProgressLearningGM from './learning/progressLearning/ProgressLearningGM';
import Error404Page from "./error/Error404Page";
import ErrorPopup from "./error/ErrorPopup";
import Account from "./account/Account";
import Sample from "./sample/Sample";
import IframeArea from "./common/iframe/IframeArea";
import QuestionInspection from "./questionInspection/QuestionInspection";
import TopicLearningV2 from "./learning/topicLearning/TopicLearningV2";
import WrapInnerRenderer from "./provider/WrapInnerRenderer";
import AibarosamInit from "./main/AibarosamInit";
import OCR from "./ocr/OCR";
import StarShopHistory from "./starShop/StarShopHistory";
import InformationGB from "./global/information/InformationGB";
import Help from "./help/Help";
import NetworkError from "./common/alert/NetworkError";
import GlobalMainV2 from "./global/main/GlobalMainV2";
import Subscribe from "./global/payment/Subscribe";
import Before from "./global/payment/Before";
import WorkSheetPage from "./worksheet/WorkSheetPage";
import SubscribeNew from "./global/payment/subscribeNew";
import GoogleLeavePage from './leave/GoogleLeavePage';
import LeaveSuccessPage from "./leave/LeaveSuccessPage";

const App = () => {
  
  return (
    <BrowserRouter>
      <LastLocationProvider>
        <Route path={ URL.LEAVE.GOOGLE_LEVEL }><GoogleLeavePage /></Route>
        <Route path={ URL.LEAVE.SUCCESS }><LeaveSuccessPage /></Route>
        <SpinnerLoading />
        <MathJax.Provider>
          <WrapInnerRenderer>
            <EntryExternalAppDataAndAutoLogin>
              <HideSplashScreen>
                <Switch>
                  <Redirect exact from={process.env.PUBLIC_URL || '/'} to={URL.SELECT_LEARNING} />
                  <Route path={ URL.SELECT_LEARNING }> {/* 메인 */}
                    <EntryCheck
                      WJTB={ <SelectLearning /> }
                      GM={ <AibarosamInit /> }
                      CP={ <AibarosamInit /> }
                      GM_APP={ <AibarosamInit /> }
                      GLOBAL01={<GlobalMainV2 />}
                    />
                  </Route>
                  <Route path={URL.STAR_SHOP_HISTORY}> {/* 별보상 히스토리 */}
                    <EntryCheck
                      GM={<StarShopHistory />}
                      GM_APP={<StarShopHistory />}
                      CP={<StarShopHistory />}
                    />
                  </Route>
                  <Route path={URL.INTRODUCTION}> {/* 제품 소개 */}
                    <EntryCheck 
                      GM={<IntroductionV2 />}
                      CP={<IntroductionV2 />}
                      GM_APP={<IntroductionV2 />}
                      GLOBAL01={<InformationGB /> }
                      WJTB={<IntroductionV2 />}
                    />
                  </Route> 
                  <Route path={[`${URL.TOPIC_LEARNING}/:thema`, `${URL.TOPIC_LEARNING}`]}> {/* 주제 학습 */}
                    <TopicLearningV2 />
                  </Route> 
                  <Route path={ URL.HELP }><Help /></Route> {/* 고객지원 */}
                  <Route path={ URL.COURSE_LEARNING.I }><CourseLearning /></Route> {/* 코스 학습, AI 진단테스트, 학습노트 */}
                  <Route path={ URL.PROGRESS_LEARNING.I }><ProgressLearningGM /></Route> {/* 진도 학습*/}
                  <Route path={ URL.TUTORIAL }><TutorialInitializer><Tutorial /></TutorialInitializer></Route>
                  <Route path={ URL.LEARNING.I }><Learning /></Route> {/* 학습결과, 오답확인, AI예측, 문제풀기*/}
                  <Route path={ URL.OCR.I }><OCR /></Route> {/* OCR */}
                  <Route path={ URL.PAYMENT.SUBSCRIBE }><Subscribe/></Route> {/* 결제 */}
                  <Route path={ URL.PAYMENT.BEFORE }><Before/></Route>  {/* 결제팝업(최초온보딩 후)*/}
                  <Route path={ URL.PAYMENT.SUBSCRIBE_NEW }><SubscribeNew/></Route>  {/* 결제팝업(인도,필리핀)*/}
                </Switch>
                <AsideV2 /> {/* Right Menu */}
                <Account /> {/* 로그인, 회원가입, ID & PW 찾기, 마이페이지 */}
              </HideSplashScreen>
            </EntryExternalAppDataAndAutoLogin>
            <Route path={URL.WORK_SHEET}><WorkSheetPage /></Route>
            <Route path={ URL.QUESTION_INSPECTION.I }><QuestionInspection /></Route>
            <Route path={ URL.SAMPLE }><Sample /></Route>

            <IframeArea />
            <Sound />
          </WrapInnerRenderer>
          <ErrorPopup />
          <NetworkError />
        </MathJax.Provider>
        <Route path={ URL.ERROR.PAGE }><Error404Page /></Route>
      </LastLocationProvider>
    </BrowserRouter>
  );

};

export default App;
